import React, { useEffect, useState } from "react";
import axios from 'axios';
import { getIdToken } from "firebase/auth";



const MaterialEditor = ({ projectId, timestamp }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  

  useEffect(() => {
  const fetchData = async () => {
    try {
      const user = window.auth?.currentUser;
      const token = user && await user.getIdToken();

      const res = await axios.get(`https://modularobjects.com/checkout/api/materials/latest/${projectId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setData(res.data); // zaboravljeno u originalu
    } catch (err) {
      console.error('❌ Greška prilikom učitavanja materijala:', err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [projectId]);



  const handleChange = (type, key, value) => {
    setData(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value
      }
    }));
  };

  const handleSave = async () => {
  try {
    const user = window.auth?.currentUser;
    const token = user && await user.getIdToken();

    const res = await fetch("https://modularobjects.com/checkout/api/materials/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    const result = await res.json();
    if (result.zipUrl) {
      window.location.href = result.zipUrl;
    } else {
      alert("Greška pri generisanju ZIP fajla.");
    }
  } catch (err) {
    console.error("❌ Greška pri slanju podataka:", err);
    alert("Greška pri čuvanju materijala.");
  }
};


  if (loading) return <div>Učitavanje...</div>;
  if (!data) return <div>Podaci nisu dostupni</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Materijali ploče</h2>
      {Object.entries(data.panelMaterials).map(([original, current]) => (
        <div key={original} className="flex gap-4 items-center">
          <label className="w-64">{original}</label>
          <input
            className="border px-2 py-1 w-80"
            value={current}
            onChange={e => handleChange("panelMaterials", original, e.target.value)}
          />
        </div>
      ))}

      <h2 className="text-xl font-bold mt-6">Materijali ivica</h2>
      {Object.entries(data.edgeMaterials|| {}).map(([original, current]) => (
        <div key={original} className="flex gap-4 items-center">
          <label className="w-64">{original}</label>
          <input
            className="border px-2 py-1 w-80"
            value={current}
            onChange={e => handleChange("edgeMaterials", original, e.target.value)}
          />
        </div>
      ))}

      <button
        onClick={handleSave}
        className="mt-6 bg-blue-600 text-white px-6 py-2 rounded"
      >
        Sačuvaj i preuzmi ZIP
      </button>
    </div>
  );
};

export default MaterialEditor;
